import React, { useState, useEffect } from "react";
import api from "../../utils/ApiMethod";
import Breadcrumb from "../../components/common/Breadcrumb";

import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Box,
  Text,
} from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";

const UpcomingEvents2 = () => {
  const [commingData, setCommingData] = useState([]);

  const handleFetchData = async () => {
    try {
      const data = await api.fetchData("/contents/events-log-en");
      setCommingData(
        data
          .filter((item) => new Date(item.eventDate) >= new Date())
          .sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate))
          .reverse(),
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  console.log("upcoming", commingData);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Upcoming Sports Events - Bihar State Sports Authority</title>
        <meta
          name="description"
          content="Stay informed about upcoming sports events and competitions organized by the Bihar State Sports Authority to promote athletic talent in Bihar."
        />
      </Helmet>

      <Breadcrumb
        pageName="D.S.O-Directory"
        pageTitle="D.S.O-Directory"
        id="#dso-directory"
        img_url="https://biharsports.org/img/annual khel 01.jpg"
        mobile_banner="https://biharsports.org/img/annual khel mobile view 576 x600 01.jpg"
      />
      <Text
        textTransform="uppercase"
        p={"4px"}
        pb={"12px"}
        fontSize={["30", "33"]}
        letterSpacing="wide"
        pt={[2, 5, 10]}
        px={[4, 10, 20]}
        fontWeight="extrabold"
      >
        Upcoming Events
      </Text>
      {!(commingData || []).length ? (
        <Box
          boxShadow={"lg"}
          marginRight={"4%"}
          marginLeft={"4%"}
          marginBottom={"30px"}
          padding={"60px 20px"}
          textAlign={"center"}
        >
          <Text fontSize={"1.5rem"} fontWeight={"medium"} color={"gray.600"}>
            Upcoming events and programme schedule will be published shortly.
          </Text>
        </Box>
      ) : (
        <Box>
          <TableContainer
            boxShadow={"lg"}
            alignContent={"center"}
            justifyContent={"center"}
            marginRight={"4%"}
            marginLeft={"4%"}
            paddingTop={"5px"}
            paddingBottom={"10px"}
          >
            <Table variant="striped" colorScheme="teal">
              <Thead>
                <Tr>
                  <Th fontSize={"1.5rem"}>Sl.No.</Th>
                  <Th fontSize={"1.5rem"}>Games</Th>
                  <Th fontSize={"1.5rem"}>The Upcoming </Th>
                </Tr>
              </Thead>
              <Tbody>
                {commingData.map((elem, index) => (
                  <Tr key={index}>
                    <Td>{index + 1}</Td>
                    <Td>{elem?.eventName}</Td>
                    <Td>{elem?.eventDateString}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
};

export default UpcomingEvents2;
